import { initializeApp, getApps } from 'firebase/app';
import { getMessaging, isSupported } from 'firebase/messaging';

const config = require("../_helpers/configServizi");

// progetto Firebase di default: lo usano i servizi senza il blocco "push" in config_servizi
const firebaseDefault = {
    apiKey: "AIzaSyClovrnRl9htJMzzuE1Z9pEhKLnQmWEcHM",
    authDomain: "pushnotification-b40e9.firebaseapp.com",
    projectId: "pushnotification-b40e9",
    storageBucket: "pushnotification-b40e9.appspot.com",
    messagingSenderId: "406118300083",
    appId: "1:406118300083:web:5f7d2cad458541225af3c6",
    measurementId: "G-06EEVXJD36"
};
const vapidKeyDefault = process.env.REACT_APP_VAPID_KEY;

// config + VAPID key vanno sempre insieme dello stesso progetto, mai mescolate
function pushDelServizio() {
    const push = config.servizi[window.location.hostname]?.push;
    if (push?.firebase?.projectId && push.vapid_key) {
        return { firebase: push.firebase, vapidKey: push.vapid_key };
    }
    return { firebase: firebaseDefault, vapidKey: vapidKeyDefault };
}

// Inizializzazione lazy: la config dei servizi arriva dopo l'import dei moduli (loadConfig in index.js).
// Restituisce { messaging, vapidKey } oppure null se il browser non supporta le push.
async function getMessagingServizio() {
    if (!(await isSupported())) return null;

    const { firebase, vapidKey } = pushDelServizio();
    const nomeApp = firebase.projectId;
    const app = getApps().find(a => a.name === nomeApp) || initializeApp(firebase, nomeApp);

    return { messaging: getMessaging(app), vapidKey };
}

export { getMessagingServizio };
